// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[isLight ? 800 : 700],
          // A tooltip is dark in BOTH themes, but the Typography override
          // paints every <Typography> with text.default — near-black in
          // light mode. Any tooltip whose content is more than a bare
          // string (a list of language pairs, a breakdown of rating
          // factors) was dark text on a dark box: present, unreadable.
          // Inside here, text follows the tooltip, not the page.
          color: theme.palette.common.white,
          // Two classes deep on purpose: the Typography override is itself a
          // single class, so a zero-specificity rule loses to it and the
          // text stays black. Anything inside a tooltip that needs its own
          // colour should set it on a Box or a span.
          '& .MuiTypography-root': { color: 'inherit' }
        },
        arrow: {
          color: theme.palette.grey[isLight ? 800 : 700]
        }
      }
    }
  };
}
